import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Link2 } from 'lucide-react';
import api from '../../utils/api';

export default function InvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/public/invite/${token}`)
      .then(r => {
        navigate(`/join/${r.data.pin}`, { replace: true });
      })
      .catch(err => {
        setError(err.response?.data?.error || 'Link ungültig oder abgelaufen');
      });
  }, [token, navigate]);

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ textAlign: 'center', maxWidth: 380 }}>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
            <Link2 size={48} color="var(--primary)" strokeWidth={1.5} />
          </div>
          <h2 style={{ marginBottom: 12 }}>Link nicht gültig</h2>
          <p style={{ color: 'var(--text3)', marginBottom: 24 }}>{error}</p>
          <a href="/join" style={{ textDecoration: 'none' }}>
            <button className="btn btn-primary">Quiz mit PIN beitreten</button>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner" style={{ margin: '0 auto 16px' }} />
        <p style={{ color: 'var(--text3)' }}>Link wird geladen...</p>
      </div>
    </div>
  );
}
